import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Stream, StreamCreate, StreamFilter } from '../data/stream';

export function createStreamService(client: AxiosInstance) {
  return createCrudService<Stream, StreamCreate, StreamFilter>(
    client,
    '/master-data/Stream',
    'id',
  );
}

export type StreamService = CrudService<Stream, StreamCreate, StreamFilter>;
